// **  Initial State
const initialState = {

}

export const assignmentReducer = (state = initialState, action) => {
	switch (action.type) {
		default:
			return state
	}
}
